// Currency handling — supports TRY, EUR, USD, GBP, Diğer (custom)

export const CURRENCIES = [
  { code: "TRY", label: "TL (₺)", symbol: "₺" },
  { code: "EUR", label: "EUR (€)", symbol: "€" },
  { code: "USD", label: "USD ($)", symbol: "$" },
  { code: "GBP", label: "GBP (£)", symbol: "£" },
  { code: "Diğer", label: "Diğer", symbol: "" },
];

export function formatMoney(amount, currency = "TRY", currencyOther = "") {
  if (amount == null || isNaN(amount)) return "—";
  const num = Number(amount);
  const suffix = currency === "Diğer" ? (currencyOther || "") : (
    CURRENCIES.find(c => c.code === currency)?.symbol || currency
  );
  const formatted = num.toLocaleString("tr-TR", { maximumFractionDigits: 0 });
  // TRY symbol goes after in TR convention; USD/EUR/GBP before
  if (currency === "TRY" || currency === "Diğer") {
    return `${formatted} ${suffix}`.trim();
  }
  return `${suffix}${formatted}`;
}
